import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DeleteAccountConfirmComponent } from './delete-account-confirm.component';
import { TranslateModule } from '@ngx-translate/core';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@NgModule({
  declarations: [DeleteAccountConfirmComponent],
  imports: [CommonModule, TranslateModule],
  exports: [DeleteAccountConfirmComponent],
  providers: [LocalizationService, TranslateModule],
})
export class DeleteAccountConfirmModule {}
